import { render } from "./corporate-mes.vue?vue&type=template&id=7c8a86ac&scoped=true"
import script from "./corporate-mes.vue?vue&type=script&lang=js"
export * from "./corporate-mes.vue?vue&type=script&lang=js"

import "./corporate-mes.vue?vue&type=style&index=0&id=7c8a86ac&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a86ac"]])

export default __exports__